import { isInSjcg } from '@king-fisher/mobileweb-lib';

const PAGE_URL = 'https://eq.10jqka.com.cn/webpage/research-report/index.html';

export function initBackwash() {
  if (!window.backWash || isInSjcg()) {
    return;
  }

  window.backWash.init({
    url: PAGE_URL,
    isRemoteConfig: true,
    pageStatConfig: {
      pageId: 'ths_mob_yanbao',
    },
    bannerConfig: {
      openBtn: {
        statId: 'ths_mob_yanbao.huiliu.open',
      },
      closeBtn: {
        statId: 'ths_mob_yanbao.huiliu.close',
      },
    },
  });

  document.onclick = e => {
    window.backWash.startApp('open');
    e.preventDefault();
  };
}
